import template from 'lodash/template';
import templateSettings from 'lodash/templateSettings';

templateSettings.interpolate = /\{(.+?)\}/g;
templateSettings.escape = /\{-(.*?)\}/g;

export default template;
